import React from "react";
import { Clock, AlertTriangle, Hourglass } from "lucide-react";
import { formatCountdown, formatDeadlineClock } from "@/lib/paymentDeadline";

/**
 * Phase 4C — panel countdown customer (display only). Phase datang dari usePaymentCountdown (satu timer).
 * none/stopped → null. Tidak mengubah status order secara lokal.
 */
export function PaymentCountdown({ order, phase, remainingMs }) {
  if (!order || phase === "none" || phase === "stopped") return null;
  const clock = formatDeadlineClock(order.payment_deadline);
  if (phase === "paused") {
    return (
      <div className="rounded-xl bg-yellow-50 border border-yellow-200 p-3 text-sm text-yellow-800" data-testid="payment-deadline-paused" data-phase={phase}>
        Permintaan pembatalan sedang ditinjau toko. Batas waktu pembayaran{clock ? ` (${clock})` : ""} tidak berjalan sebagai tenggat aktif selama peninjauan.
      </div>
    );
  }
  if (phase === "expired") {
    return (
      <div className="rounded-xl bg-[#FAF9F6] border border-[#E5E5E5] p-4 text-sm text-[#1A1A1A]" role="status" data-testid="payment-deadline-expired" data-phase={phase}>
        <div className="flex items-center gap-2 font-bold"><Hourglass size={16} /> Batas waktu pembayaran telah berakhir.</div>
        <div className="text-[#5C5C5C] mt-1">Sistem sedang memperbarui status pesanan.</div>
      </div>
    );
  }
  const warning = phase === "warning";
  return (
    <div className={`rounded-xl p-4 border ${warning ? "bg-amber-50 border-amber-400" : "bg-[#FAF9F6] border-[#E5E5E5]"}`}
      role={warning ? "alert" : "status"} data-testid="payment-countdown" data-phase={phase}>
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="text-[10px] uppercase tracking-widest font-bold text-[#5C5C5C] flex items-center gap-1">
            {warning ? <AlertTriangle size={12} className="text-amber-600" /> : <Clock size={12} />} Batas Waktu Pembayaran
          </div>
          <div className={`font-display font-black text-3xl tabular-nums ${warning ? "text-amber-700" : ""}`} data-testid="payment-countdown-value" aria-live="off">
            {formatCountdown(remainingMs)}
          </div>
        </div>
        {clock && <div className="text-xs text-[#5C5C5C]" data-testid="payment-deadline-clock">Bayar sebelum <b>{clock}</b></div>}
      </div>
      {warning ? (
        <div className="mt-2 text-sm text-amber-800" data-testid="payment-countdown-warning">
          <b>Waktu pembayaran hampir habis.</b> Setelah membayar, jangan lupa tekan <b>'Sudah Membayar'</b>.
        </div>
      ) : (
        <div className="mt-2 text-sm text-[#5C5C5C]" data-testid="payment-countdown-hint">
          Selesaikan pembayaran dan tekan <b>'Sudah Membayar'</b> sebelum waktu habis.
        </div>
      )}
    </div>
  );
}
